import React from 'react';
import CTAButton from './CTAButton';
import { StarIcon } from 'lucide-react';
const TwoColumnIntro = () => {
  return <div className="relative mt-6 pb-6" data-id="element-248">
      {/* Main content area - only visible on mobile */}
      <div className="md:hidden p-4 py-5" data-id="element-249">
        <h1 className="text-3xl font-bold mb-5 text-center" data-id="element-250">
          I Treated 10,000 Men Who Couldn't Lose Weight: Here's The Real Problem
          Their Doctors Missed
        </h1>
        <p className="italic mb-5 text-center" data-id="element-251">
          My breakthrough research reveals why men over 30 can't burn belly fat
          or build muscle - even when they're doing everything right
        </p>
        <div className="flex items-center mt-4 mb-4 justify-center" data-id="element-252">
          <div className="w-16 h-16 rounded-full mr-4 flex-shrink-0 overflow-hidden" data-id="element-253">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/evhLVhHHaVy63mHQnoEAhS/Dr._Chen.png" alt="Dr. Marcus Chen, MD" className="w-full h-full object-cover" data-id="element-254" />
          </div>
          <p className="text-sm text-left" data-id="element-255">
            By Dr. Marcus Chen, MD
            <br data-id="element-256" />
            Harvard-Trained Endocrinologist
          </p>
        </div>
      </div>
      {/* Main content area - desktop version */}
      <div className="hidden md:block p-4" data-id="element-257">
        <h1 className="text-3xl font-bold mb-4" data-id="element-258">
          I Treated 10,000 Men Who Couldn't Lose Weight: Here's The Real Problem
          Their Doctors Missed
        </h1>
        <p className="italic mb-4" data-id="element-259">
          My breakthrough research reveals why men over 30 can't burn belly fat
          or build muscle - even when they're doing everything right
        </p>
        <div className="flex items-center mt-3" data-id="element-260">
          <div className="w-16 h-16 rounded-full mr-2 flex-shrink-0 overflow-hidden" data-id="element-261">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/evhLVhHHaVy63mHQnoEAhS/Dr._Chen.png" alt="Dr. Marcus Chen, MD" className="w-full h-full object-cover" data-id="element-262" />
          </div>
          <p className="text-sm" data-id="element-263">
            By Dr. Marcus Chen, MD
            <br data-id="element-264" />
            Harvard-Trained Endocrinologist
          </p>
        </div>
      </div>
      {/* Product area - Mobile version (not sticky) */}
      <div className="md:hidden bg-gray-100 p-4 mt-6 rounded-lg" data-id="element-265">
        <div className="text-center" data-id="element-266">
          <h2 className="text-xl font-bold mb-2" data-id="element-267">
            Finally, lose stubborn weight - even if nothing's worked before
          </h2>
          <div className="flex items-center justify-center mb-4" data-id="element-268">
            <div className="flex text-yellow-400" data-id="element-269">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-270" />)}
            </div>
            <span className="ml-2 text-sm" data-id="element-271">47,819 Reviews</span>
          </div>
          <div className="w-48 h-48 mx-auto mb-4" data-id="element-272">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cWqX7mxAcDbt8Snp6uGQZV/Mockup1.png" alt="Drift Supplement Bottle" className="w-full h-full object-contain" data-id="element-273" />
          </div>
          <CTAButton data-id="element-274" />
        </div>
      </div>
      {/* Product area - Desktop version (sticky) */}
      <div className="hidden md:block fixed top-20 md:right-auto md:left-1/2 md:ml-48 w-1/3 max-w-xs bg-gray-100 p-6 rounded-lg shadow-md" data-id="element-275">
        <div className="text-center" data-id="element-276">
          <h2 className="text-xl font-bold mb-2" data-id="element-277">
            Finally, lose stubborn weight - even if nothing's worked before
          </h2>
          <div className="flex items-center justify-center mb-4" data-id="element-278">
            <div className="flex text-yellow-400" data-id="element-279">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-280" />)}
            </div>
            <span className="ml-2 text-sm" data-id="element-281">47,819 Reviews</span>
          </div>
          <div className="w-48 h-48 mx-auto mb-4" data-id="element-282">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cWqX7mxAcDbt8Snp6uGQZV/Mockup1.png" alt="Drift Supplement Bottle" className="w-full h-full object-contain" data-id="element-283" />
          </div>
          <CTAButton data-id="element-284" />
        </div>
      </div>
    </div>;
};
export default TwoColumnIntro;